<div class="container-fluid main-container">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
</div>